<template>
<div class="chapter">
<div class="inner_page">
<div style="display:none;"><a id="GBS.PP1"></a><a id="GBS.PP1.w.0.0.0"></a></div>
<div class="flow" style="">
</div>
<div class="flow" style="">
<div class="gimg_graphic" id="block.0.3.0.box.56.1632.1314.800.q.101">
<a id="GBS.PP1.w.1.0.0"></a><a id="GBS.PP1.w.1.0.0.1"></a></div>
</div>
<div class="flow" style="">
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PP3"></a>
<a id="GBS.PP1.w.2.0.0"></a><img alt="Image for page 2" src="data/content-0002.png" style="max-width:100%; max-height:100%"/><a id="GBS.PP1.w.2.0.0.1"></a></div>
<div class="flow" style="">
</div>
<div class="flow" style="">
</div>
<div class="flow" style="">
<a class="page" id="ORIG-GBS.PP6"></a>
<div class="gimg_graphic" id="block.5.0.0.box.40.150.1507.2248.q.101">
<a id="GBS.PP1.w.3.0.0"></a><img alt="[graphic]" src="data/content-0003.jpg" style="max-width:100%; max-height:100%"/><a id="GBS.PP1.w.3.0.0.1"></a></div>
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PP7"></a>
<a id="GBS.PP2"></a><a id="GBS.PP2.w.0.0.0"></a><img alt="Image for page 6" src="data/content-0004.png" style="max-width:100%; max-height:100%"/><a id="GBS.PP2.w.0.0.0.1"></a></div>
<div style="display:none;"><a id="GBS.PP2.w.0.0.0.2"></a></div><div style="display:none;"><a id="GBS.PP3"></a><a id="GBS.PP3.w.0.0.0"></a></div><div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PP8"></a>
<a id="GBS.PP3.w.1.0.0"></a><img alt="Image for page 7" src="data/content-0005.png" style="max-width:100%; max-height:100%"/><a id="GBS.PP3.w.1.0.0.1"></a></div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page" id="ORIG-GBS.PP9"></a>
<div class="gtxt_body" id="block.8.0.0.box.383.640.816.189.q.40">
<a id="ORIG-GBS.PP9.w.0.0.0"></a><p class="gtxt_body" id="para.8.0.0.box.766.640.55.38.q.70" style="font-size:102%;text-align:center;">To</p>
<a id="ORIG-GBS.PP9.w.0.1.0"></a><p class="gtxt_body" id="para.8.0.1.box.383.702.816.47.q.60" style="font-size:102%;text-align:center;"><a id="GBS.PP3.w.2.0.0"></a><a id="GBS.PP3.w.3.0.0"></a><a id="GBS.PP4"></a><a id="GBS.PP4.w.0.0.0"></a>My Wife, Laura McClos<a id="GBS.PP5"></a><a id="GBS.PP5.w.0.0.0"></a>key Clement.</p><a id="GBS.PP6"></a><a id="GBS.PP6.w.0.0.0"></a><a id="GBS.PP6.w.0.1.0"></a>
<a id="GBS.PP6.w.0.1.0.1"></a><a id="GBS.PP6.w.1.0.0"></a><a id="ORIG-GBS.PP9.w.0.2.0"></a><p class="gtxt_body" id="para.8.0.2.box.968.791.230.38.q.40" style="font-size:102%;text-align:right;margin-right:2em;"><a id="GBS.PP7"></a><a id="GBS.PP7.w.0.0.0"></a><a id="GBS.PP7.w.0.1.0"></a><a id="GBS.PP7.w.1.0.0"></a><a id="GBS.PP7.w.1.1.0"></a><a id="GBS.PP7.w.2.0.0"></a>—W. E. C.</p><a id="GBS.PP7.w.3.0.0"></a><a id="GBS.PP7.w.4.0.0"></a>
</div><a id="GBS.PP7.w.4.1.0"></a><a id="GBS.PP8"></a><a id="GBS.PP8.w.0.0.0"></a>
</div><div style="display:none;"><a id="GBS.PP8.w.1.0.0"></a></div><div style="display:none;"><a id="GBS.PP9"></a><a id="GBS.PP9.w.0.0.0"></a></div><div style="display:none;"><a id="GBS.PP9.w.0.1.0"></a></div>
<div style="display:none;"><a id="GBS.PP9.w.0.1.0.1"></a></div><div style="display:none;"><a id="GBS.PP10"></a><a id="GBS.PP10.w.0.0.0"></a></div><div class="flow" style=""><a id="GBS.PP11"></a><a id="GBS.PP11.w.0.0.0"></a>
</div><div style="display:none;"><a id="GBS.PP11.w.1.0.0"></a></div><div style="display:none;"><a id="GBS.PP11.w.2.0.0"></a></div><div style="display:none;"><a id="GBS.PP11.w.3.0.0"></a></div>
<div style="display:none;"><a id="GBS.PP11.w.3.0.0.1"></a></div><div style="display:none;"><a id="GBS.PP11.w.4.0.0"></a></div><div class="flow" style=""><a id="GBS.PP11.w.5.0.0"></a>
<a class="page full_page_skipped" id="ORIG-GBS.PP11"></a><a id="GBS.PP11.w.6.0.0"></a>
</div><div style="display:none;"><a id="GBS.PP11.w.7.0.0"></a></div><div style="display:none;"><a id="GBS.PP11.w.8.0.0"></a></div>
<div class="flow" style="">
</div><div style="display:none;"><a id="GBS.PP11.w.9.0.0"></a></div>
<div style="display:none;"><a id="GBS.PP11.w.9.0.0.1"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content-0006.vue?288174b8